import React, { useState } from "react";
import { Box, Container, Grid, Typography, useMediaQuery } from "@mui/material";
import { BsCopy } from "react-icons/bs";
import CopyToClipboard from "react-copy-to-clipboard";
import { ToastNotify } from "../components/SmallComponents/AppComponents";
import { coins } from "../components/SmallComponents/Images";
export default function Tokenomics() {
  const matches = useMediaQuery("(max-width:950px)");
  const [alertState, setAlertState] = useState({
    open: false,
    message: "",
    severity: undefined,
  });
  return (
    <Box my={matches ? 5 : 10} id="tokenomics">
      <ToastNotify alertState={alertState} setAlertState={setAlertState} />

      <Container>
        <Typography
          sx={{
            fontFamily: "Lilita One",
            fontSize: { xs: "45px", sm: "70px" },
            lineHeight: { xs: "40px", sm: "30px" },
            textAlign: "center",
            color: "#65CD2E",
            WebkitTextStroke: "3px #ffffff",
          }}
        >
          Token Information
        </Typography>
        <Box display="flex" justifyContent="center" mt={5}>
          <img src={coins} width={matches ? "80%" : "50%"} alt="" />
        </Box>

        <Grid container spacing={matches ? 3 : 7} mt={1}>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                background: "#27ADFB",
                borderRadius: "16px",
                width: "100%",
                height: "70px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                boxShadow:
                  "0px 13px 13.600000381469727px 0px #00000040, 0px 4px 7.599999904632568px 0px #00000029",
              }}
            >
              <Typography
                pl={2}
                sx={{
                  textAlign: "center",
                  fontFamily: "Lilita One",
                  fontSize: { xs: "22px", md: "36px" },
                  fontWeight: "400",
                  color: "#fff",
                }}
              >
                Symbol :
              </Typography>
              <Typography
                pr={2}
                sx={{
                  textAlign: "center",
                  fontFamily: "Montserrat",
                  fontSize: { xs: "20px", md: "32px" },
                  fontWeight: "400",
                  color: "#fff",
                }}
              >
                BARFBOY
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                background: "#27ADFB",
                borderRadius: "16px",
                width: "100%",
                height: "70px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                boxShadow:
                  "0px 13px 13.600000381469727px 0px #00000040, 0px 4px 7.599999904632568px 0px #00000029",
              }}
            >
              <Typography
                pl={2}
                sx={{
                  textAlign: "center",
                  fontFamily: "Lilita One",
                  fontSize: { xs: "22px", md: "36px" },
                  fontWeight: "400",
                  color: "#fff",
                }}
              >
                Decimal :
              </Typography>
              <Typography
                pr={2}
                sx={{
                  textAlign: "center",
                  fontFamily: "Montserrat",
                  fontSize: { xs: "20px", md: "32px" },
                  fontWeight: "400",
                  color: "#fff",
                }}
              >
                6
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} md={12}>
            <Box
              sx={{
                background: "#65CD2E",
                borderRadius: "16px",
                width: "100%",
                height: "70px",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                boxShadow:
                  "0px 13px 13.600000381469727px 0px #00000040, 0px 4px 7.599999904632568px 0px #00000029",
              }}
            >
              <Typography
                pl={2}
                sx={{
                  textAlign: "center",
                  fontFamily: "Lilita One",
                  fontSize: { xs: "22px", md: "36px" },
                  fontWeight: "400",
                  color: "#fff",
                }}
              >
                Token Address :
              </Typography>

              <Typography
                pr={2}
                sx={{
                  textAlign: "center",
                  fontFamily: "Montserrat",
                  fontSize: { xs: "18px", md: "22px" },
                  fontWeight: "400",
                  color: "#fff",
                }}
              >
                {matches
                  ? "mVuzEMo5n4p6iHNFGWsFkACB2F1vNmW8BdwoyKApump".slice(0, 4) +
                    "..." +
                    "mVuzEMo5n4p6iHNFGWsFkACB2F1vNmW8BdwoyKApump".slice(-4)
                  : "mVuzEMo5n4p6iHNFGWsFkACB2F1vNmW8BdwoyKApump"}

                <CopyToClipboard
                  text={"mVuzEMo5n4p6iHNFGWsFkACB2F1vNmW8BdwoyKApump"}
                  onCopy={() => {
                    setAlertState({
                      open: true,
                      message: `Token Address Copied.`,
                      severity: "success",
                    });
                  }}
                >
                  <BsCopy
                    style={{
                      fontSize: "22px",
                      color: "#fff",
                      marginLeft: "10px",
                      cursor: "pointer",
                    }}
                  />
                </CopyToClipboard>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
